import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { axios } from "@via/api/axios.tsx";
import { type ListAvailableAIModelsResponse } from "common";

export const fetchAvailableAIModels = async (
  serviceTokenId: number
): Promise<ListAvailableAIModelsResponse> => {
  try {
    const res = await axios.get("/api/v1/ai/models", {
      params: { serviceTokenId },
    });
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const useAvailableAIModels = (
  serviceTokenId: number | undefined
): UseQueryResult<ListAvailableAIModelsResponse> => {
  return useQuery<ListAvailableAIModelsResponse>({
    queryKey: ["/api/v1/ai/models", serviceTokenId],
    queryFn: async () => await fetchAvailableAIModels(serviceTokenId!),
    enabled: !!serviceTokenId,
  });
};
